module.exports = __webpack_public_path__ + "img/mary_pickford.0f99dea1.jpg";